import React from 'react';
import PropTypes from 'prop-types';
import { Box, Typography } from '@mui/material';
import tvTheme, { tvTextStroke } from './tvTheme';

/** 日別版 TVIntroPanel と同じタイポ・装飾（週間版の文言のみ差し替え） */
const introSizes = (compact) => ({
  channel: compact ? '1rem' : 'clamp(1.1rem, 1.8vw, 1.5rem)',
  title: compact ? '1.75rem' : 'clamp(2.75rem, 7vw, 4.25rem)',
  date: compact ? '1.1rem' : 'clamp(1.5rem, 3.5vw, 2.6rem)',
  headline: compact ? '1.05rem' : 'clamp(1.35rem, 3vw, 2.25rem)',
});

function TVWeeklyIntroPanel({ data, compact = false }) {
  if (!data) return null;
  const sizes = introSizes(compact);
  const ticker = [data.coverageLabel, data.trialLabel].filter(Boolean).join(' ｜ ');

  return (
    <Box
      sx={{
        flex: 1,
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        minHeight: 0,
        width: '100%',
        gap: compact ? 0.5 : 0.75,
        px: compact ? 0.5 : 1,
        py: compact ? 0.25 : 0.5,
        pt: compact ? 3.5 : 5,
        pr: compact ? 4.5 : 6.5,
      }}
    >
      <Typography
        sx={{
          fontSize: sizes.channel,
          fontWeight: 800,
          color: '#fff',
          ...tvTextStroke('#1565b8'),
          letterSpacing: '0.06em',
          textAlign: 'center',
        }}
      >
        {data.channel}
      </Typography>

      <Typography
        component="h1"
        sx={{
          fontSize: sizes.title,
          fontWeight: 900,
          color: tvTheme.colors.titleOrange,
          ...tvTextStroke('#fff'),
          lineHeight: 1.08,
          letterSpacing: '0.02em',
          textAlign: 'center',
        }}
      >
        {data.title}
      </Typography>

      <Typography
        sx={{
          fontSize: sizes.date,
          fontWeight: 900,
          color: '#fff',
          ...tvTextStroke(tvTheme.colors.accentBlue),
          textAlign: 'center',
          letterSpacing: '0.04em',
          lineHeight: 1.15,
        }}
      >
        {data.periodLabel}
      </Typography>

      {data.headline && (
        <Box
          sx={{
            width: '100%',
            mx: 'auto',
            px: compact ? 1 : 1.75,
            py: compact ? 1 : 1.75,
            borderRadius: 2,
            bgcolor: 'rgba(255,255,255,0.94)',
            border: '4px solid #fff',
            boxShadow: '0 6px 28px rgba(13,74,143,0.28)',
          }}
        >
          <Typography
            sx={{
              fontSize: sizes.headline,
              fontWeight: 800,
              color: tvTheme.colors.textDark,
              lineHeight: 1.35,
              textAlign: 'center',
            }}
          >
            {data.headline}
          </Typography>
        </Box>
      )}

      {ticker ? (
        <Box
          sx={{
            flexShrink: 0,
            px: compact ? 1 : 1.5,
            py: compact ? 0.55 : 0.85,
            background: tvTheme.colors.tickerBar,
            borderTop: '4px solid #fff',
            borderRadius: 1,
          }}
        >
          <Typography
            sx={{
              color: '#fff',
              fontSize: compact ? '0.75rem' : '1.05rem',
              fontWeight: 800,
              ...tvTextStroke('#0d47a1'),
              textAlign: 'center',
            }}
          >
            {ticker}
          </Typography>
        </Box>
      ) : null}
    </Box>
  );
}

TVWeeklyIntroPanel.propTypes = {
  data: PropTypes.shape({
    channel: PropTypes.string,
    title: PropTypes.string,
    periodLabel: PropTypes.string,
    coverageLabel: PropTypes.string,
    headline: PropTypes.string,
    trialLabel: PropTypes.string,
  }),
  compact: PropTypes.bool,
};

export default TVWeeklyIntroPanel;
